import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.33301 16.5002C5.33301 15.7638 5.92996 15.1668 6.66634 15.1668H25.333C26.0694 15.1668 26.6663 15.7638 26.6663 16.5002C26.6663 17.2365 26.0694 17.8335 25.333 17.8335H6.66634C5.92996 17.8335 5.33301 17.2365 5.33301 16.5002Z",
		fill: "#BBCCD8"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.0569 6.22402C15.5776 5.70332 16.4218 5.70332 16.9425 6.22402L26.2758 15.5574C26.7965 16.0781 26.7965 16.9223 26.2758 17.443L16.9425 26.7763C16.4218 27.297 15.5776 27.297 15.0569 26.7763C14.5362 26.2556 14.5362 25.4114 15.0569 24.8907L23.4474 16.5002L15.0569 8.10964C14.5362 7.58894 14.5362 6.74472 15.0569 6.22402Z",
		fill: "#BBCCD8"
	})]
});
export { SvgArrowRight as ReactComponent };
